import clsx from 'clsx';

import { DeleteItemPopover } from '~components/generic/DeleteItemPopover/DeleteItemPopover';
import { TrashIcon } from '~components/icons/TrashIcon';
import { UploadIcon } from '~components/icons/UploadIcon';
import ProgressBar from '~modules/media-library/view/Contribute/UploadAssetsForm/ProgressBar';
import { bytesToMB } from '~utils/bytesToMB';
import styles from './UploadItem.module.css';

interface UploadItemProps {
  file: ContributeFile;
  handleDelete?: () => void;
}

const UploadItem = ({ file, handleDelete }: UploadItemProps) => {
  return (
    <div className={clsx(styles['item-container'], file.contributionDone ? styles.itemContributionDone : ' ')}>
      <UploadIcon />
      <div className={styles['information-container']}>
        <div className={styles['information']}>
          <div>
            <p>{file.fileName}</p>
            <span>{bytesToMB(file.fileSize)}MB</span>
          </div>

          <DeleteItemPopover icon={<TrashIcon />} onDelete={handleDelete} />
        </div>

        <div className={styles.progressBarContainer}>
          <ProgressBar progress={file.progress} />
          {file.progress && (
            <p className={styles.progressPercentage}>
              <span className="whitespace-nowrap">{file.progress} %</span>
            </p>
          )}
        </div>
        <p className={styles.error}>{file.errorMessage}</p>
      </div>
    </div>
  );
};

export default UploadItem;
